import { Box, type BoxProps, Card, Text, ThemeIcon } from '@mantine/core'
import { useState, useEffect, type PropsWithChildren } from 'react'

import { useTranslation } from '@flecto/translations'
import { useAddressCountryFlag } from '@flecto/utils'

import { useTaxProfileFormContext } from '../TaxesFormProvider/TaxesFormProvider'
import classes from './styles.module.css'

export function TaxesLocationCard(props: PropsWithChildren<BoxProps>) {
  const getFlag = useAddressCountryFlag()
  const form = useTaxProfileFormContext()
  const [countryLine, setCountryLine] = useState('')
  const { t } = useTranslation('saas', { keyPrefix: 'profile_taxes' })

  useEffect(() => {
    const { legal_address } = form.values

    if (legal_address?.address_region && legal_address?.address_country_name) {
      setCountryLine(
        `${legal_address.address_region}, ${legal_address.address_country_name}`
      )
    } else if (
      !legal_address?.address_region &&
      legal_address?.address_country_name
    ) {
      setCountryLine(`${legal_address.address_country_name}`)
    }
  }, [form.values])

  return (
    <Card {...props}>
      <Box className={classes.wrapper}>
        <ThemeIcon variant='light' color='gray' className={classes.icon}>
          <Text size='xl'>
            {getFlag(form.values.legal_address?.address_country_code)}
          </Text>
        </ThemeIcon>
        <Box className={classes.content}>
          <Text fw={500}>
            {t('taxes_location_card.title', { replace: { countryLine } })}
          </Text>
          <Text color='dimmed'>
            {form.values.meta?.invoicing_supported
              ? t('taxes_location_card.description_with_supported_taxes')
              : t('taxes_location_card.description_with_no_supported_taxes')}
          </Text>
        </Box>
      </Box>
    </Card>
  )
}
